import Vue from "vue";

function renewReservations(state) {
  state.reservations = [];
  state.bookings.forEach(booking => {
    if (booking.reservations) {
      booking.reservations.forEach(reservation => {
        reservation.booking_id = booking.id;
        reservation.booking_name = booking.name;
        reservation.booking_notes = booking.notes;
        reservation.booking_discount = booking.booking_discounts && !!booking.booking_discounts.length
          ? booking.booking_discounts[0].discount_code
          : '';

        state.reservations.push(reservation);
      });
    }
  });
}

function updateTabs(state, updatedTab) {
  const openTabIndex = state.openTabs.findIndex(tab => updatedTab.id === tab.id)
  if (openTabIndex) Vue.set(state.openTabs, openTabIndex, updatedTab)

  const openActiveTabIndex = state.openActiveTabs.findIndex(tab => updatedTab.id === tab.id)
  if (openActiveTabIndex) Vue.set(state.openActiveTabs, openActiveTabIndex, updatedTab)
}

function createFilters(keyObject) {
  const filters = Object.keys(keyObject).map(key => `${key}=${keyObject[key]}`)
  return filters.reduce((sum, newFilter) => sum += `&${newFilter}`)
}

export {createFilters, renewReservations, updateTabs}